import { Outlet, createFileRoute } from '@tanstack/react-router'

import { BankIdProvider } from '@/integrations/bankid/useBankId'

export const Route = createFileRoute('/login')({
  component: LoginLayout,
})

function LoginLayout() {
  return (
    <BankIdProvider>
      <Outlet />
    </BankIdProvider>
  )
}
